import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'
import DynamicFieldItem, {
  SECTION
} from 'Components/DynamicFiledItem/DynamicFieldItem'
import { modalCheckupState } from 'Components/ModalCheckup/recoil/state'
import PropTypes from 'prop-types'
import { ICON_ALERT } from 'Components/CheckItem/CheckItem'
import { Link, LINK_VARIANT_EXTRALIGHT } from 'mailup-web-components'

const DynamicFieldSubject = ({ wrongDynamicTagsGroup }) => {
  const intl = useIntl()
  const [
    { dynamicFieldsOptionEnabled, addToWhiteList },
    setModalState
  ] = useRecoilState(modalCheckupState)

  const handleClick = (e, section) => {
    e.stopPropagation()
    e.preventDefault()

    setModalState(prev => ({
      ...prev,
      show: false
    }))
  }

  return (
    <>
      {wrongDynamicTagsGroup && 'Subject' in wrongDynamicTagsGroup && (
        <>
          <DynamicFieldItem
            section={SECTION.subject}
            items={wrongDynamicTagsGroup.Subject}
            intl={intl}
            badge={
              !dynamicFieldsOptionEnabled
                ? intl.formatMessage({
                    id: 'Load.EmailCheckUp.WarningLabel'
                  })
                : ''
            }
            icon={!dynamicFieldsOptionEnabled ? ICON_ALERT : ''}
            title={
              'Preheader' in wrongDynamicTagsGroup
                ? ''
                : intl.formatMessage({
                    id: 'Load.EmailCheckUp.SecntionDynamicFields'
                  })
            }
            description={intl.formatMessage(
              {
                id: 'Load.EmailCheckUp.DynamicFieldsHeaderTitleIntl'
              },
              {
                link: e => (
                  <Link
                    variant={LINK_VARIANT_EXTRALIGHT}
                    key={1}
                    onClick={e => handleClick(e, SECTION.subject)}
                  >
                    {e}
                  </Link>
                )
              }
            )}
            setModalState={setModalState}
            addToWhiteList={addToWhiteList}
          />
        </>
      )}
    </>
  )
}

DynamicFieldSubject.propTypes = {
  wrongDynamicTagsGroup: PropTypes.any
}

export default DynamicFieldSubject
